module.exports = __webpack_public_path__ + "ebbddcf1e3b17eb0ec5a394a99bcafd6.png";